import { defineComponent, h } from 'vue';
import { QDialog, QCard, QCardSection, QCardActions, QBar, QToolbarTitle, QBtn, QSeparator, QSpace } from 'quasar';

export default defineComponent({
    name: 'flowv2-generic-dialog',
    components: { QDialog, QCard, QCardSection, QCardActions, QBar, QToolbarTitle, QBtn, QSeparator, QSpace },
    emits: ['cancel','ok'],
    data: () => ({
        title: '',
        content: null,
        showing: false,
        maxwidth: 800,
        dialogWidth: '800px',
        saveFunc: null,
        allowResize: true,
        hideSaveButton: false,
        canSave: null,
    }),
    props: {
    },
    mounted() {
    },
    methods: {
        normalizeWidth(width) {
            if (width === null || width === undefined || width === '')
                return `${this.maxwidth}px`;

            if (typeof width === 'number')
                return `${width}px`;

            if (typeof width === 'string')
                return width;

            return `${this.maxwidth}px`;
        },
        showDialog(title, maxwidth, content, saveFunc) {
            this.content = content;
            this.maxwidth = maxwidth ?? this.maxwidth;
            this.dialogWidth = this.normalizeWidth(this.maxwidth);
            this.title = title;
            this.saveFunc = saveFunc;
            this.hideSaveButton = !saveFunc;
            this.canSave = null;
            this.showing = true;
        },
        hideDialog() {
            this.showing = false;
        },
        Okay() {
            if (this.canSave && !this.canSave())
                return;
            this.showing = false;
            if (this.saveFunc)
                this.saveFunc();
        }
    },
    render() {
        return (
            <QDialog
                modelValue={this.showing}
                onUpdate:modelValue={(v) => { this.showing = v; }}
                maximized={false}
                class="flowv2-generic-dialog"
                persistent
            >
                <QCard
                    class="column no-wrap"
                    style={{
                        width: this.dialogWidth,
                        maxWidth: 'calc(100vw - 24px)',
                        maxHeight: '90vh',
                        minHeight: '140px',
                        minWidth: '320px',
                        resize: this.allowResize ? 'both' : 'none',
                        overflow: 'hidden'
                    }}
                >
                    <QBar class="bg-primary text-white" style={{ flexShrink: 0 }}>
                        <QToolbarTitle>{this.title}</QToolbarTitle>
                        <QSpace />
                        <QBtn flat round dense icon="mdi-close" onClick={() => this.showing = false} />
                    </QBar>

                    <QCardSection style="flex: 1 1 auto; min-height: 0; min-width: 0; display: flex; flex-direction: column; overflow-x: hidden; overflow-y: auto;">
                        {this.content ? this.content(this) : null}
                    </QCardSection>

                    <QSeparator />

                    {!this.hideSaveButton && (
                        <QCardActions align="right" style="flex: 0 0 auto;">
                            <QSpace />
                            <QBtn unelevated color="primary" label="OK" disable={this.canSave ? !this.canSave() : false} onClick={() => this.Okay()} />
                        </QCardActions>
                    )}
                </QCard>
            </QDialog>
        );
    }
});
